module.exports = __webpack_public_path__ + "img/vi_24px.652e9ed3.svg";